import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionLabel, StatusBadge, Reveal } from "@/components/bits";

export default function StatusPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/status").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const allUp = items.length > 0 && items.every((i) => i.status === "undetected");

  return (
    <div className="pt-32 pb-28 mx-auto max-w-[1100px] px-5 sm:px-8" data-testid="status-page">
      <SectionLabel>LIVE SYSTEM STATUS</SectionLabel>
      <h1 className="mt-4 font-display text-5xl sm:text-7xl uppercase leading-none">Status</h1>

      <div className="mt-8 flex items-center gap-4 rounded-2xl border border-white/15 px-6 py-5">
        <span className={`h-3 w-3 rounded-full ${allUp ? "bg-white pulse-dot" : "bg-zinc-600"}`} />
        <span className="font-mono text-sm tracking-[0.15em]">
          {allUp ? "ALL SYSTEMS OPERATIONAL — EVERY CHEAT UNDETECTED & RUNNING SMOOTH" : "CHECKING STATUS..."}
        </span>
      </div>

      <div className="mt-10 rounded-2xl overflow-hidden border border-white/10" data-testid="status-list">
        <div className="grid grid-cols-[1fr_auto] gap-4 px-6 py-4 border-b border-white/10 font-mono text-[10px] tracking-[0.25em] text-white/40">
          <span>PRODUCT</span><span>STATUS</span>
        </div>
        {items.map((i, idx) => (
          <Reveal key={i.slug} delay={idx * 0.03}>
            <div className="grid grid-cols-[1fr_auto_auto] items-center gap-4 px-6 py-5 border-b border-white/[0.06] hover:bg-white/[0.02] transition-colors">
              <div>
                <div className="font-display text-lg uppercase leading-none">{i.name}</div>
                <div className="mt-1 font-mono text-[10px] tracking-[0.2em] text-white/35">{i.game}</div>
              </div>
              {i.days_undetected > 0 && (
                <span className="font-mono text-[10px] tracking-[0.2em] text-white/60 rounded-full border border-white/15 px-3 py-1.5" data-testid={`status-streak-${i.slug}`}>
                  {i.days_undetected} DAYS CLEAN
                </span>
              )}
              <StatusBadge status={i.status} />
            </div>
          </Reveal>
        ))}
      </div>

      {/* detection history timeline */}
      {items.some((i) => i.days_undetected > 0) && (
        <div className="mt-16" data-testid="detection-history">
          <h2 className="font-display text-3xl uppercase mb-8">Detection History</h2>
          <div className="border-l-2 border-white/15 ml-2 space-y-10">
            <div className="relative pl-8">
              <span className="absolute -left-[7px] top-1 h-3 w-3 rounded-full bg-zinc-600" />
              <div className="font-mono text-xs tracking-[0.15em] text-white/50">
                {new Date(items.find((i) => i.undetected_since).undetected_since + "T00:00:00Z").toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" })}
              </div>
              <div className="mt-1 font-display text-xl uppercase">Detection event — patched &amp; restored</div>
              <div className="mt-1 font-mono text-[10px] tracking-[0.15em] text-white/40">EVERY CHEAT + SPOOFER BACK ONLINE · COUNTERS RESTARTED</div>
            </div>
            <div className="relative pl-8">
              <span className="absolute -left-[7px] top-1 h-3 w-3 rounded-full bg-white pulse-dot" />
              <div className="font-mono text-xs tracking-[0.15em] text-white/50">TODAY</div>
              <div className="mt-1 font-display text-xl uppercase" data-testid="streak-counter">
                Undetected — {Math.max(...items.map((i) => i.days_undetected || 0))} days and counting
              </div>
              <div className="mt-1 font-mono text-[10px] tracking-[0.15em] text-white/40">EVERY MENU + SPOOFER RUNNING CLEAN</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
